// extracted by mini-css-extract-plugin
module.exports = {"trendingThisMonthSectionContainer":"TrendingThisMonthSection_trendingThisMonthSectionContainer__dbO46"};